import { useSelector } from 'react-redux';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectPaidReportExperiment } from 'shared/selectors/abExperiments/selectPaidReport';

import type { IState } from 'shared/store';

export const usePaidReportExperiment = (): boolean => {
  const { config } = useApplicationContext();
  const notTargetRegions = config.get<number[]>('Sellers.paidReportRegions') || [];

  return useSelector((state: IState) => selectPaidReportExperiment(state, notTargetRegions));
};
